import { Save } from "@mui/icons-material";
import LoadingButton from "@mui/lab/LoadingButton";
import {
  Box,
  Container,
  DialogContent,
  DialogTitle,
  Divider,
  Fab,
} from "@mui/material";
import React from "react";
import AdminAppBar from "../../admin/components/AdminAppBar";
import AdminToolbar from "../../admin/components/AdminToolbar";

export const StyledBox = ({
  children,
  title,
  description,
  additionalStyles,
}: {
  children: React.ReactNode;
  title?: string;
  description?: string;
  additionalStyles?: React.CSSProperties;
}) => {
  const childrenArray = React.Children.toArray(children);
  let styles: React.CSSProperties = {
    marginBottom: 15,
    marginLeft: 10,
    marginRight: 10,
    padding: 25,
    borderStyle: "groove",
    borderColor: "rgba(0,0,0,0.12)",
    borderRadius: 15,
    backgroundColor: "rgba(255,255,255,0.99)",
  };
  if (additionalStyles) {
    styles = { ...styles, ...additionalStyles };
  }

  return (
    <Box style={styles}>
      {title && <DialogTitle>{title}</DialogTitle>}
      {description && (
        <>
          <DialogContent>{description}</DialogContent>
          <Divider style={{ marginTop: 5, marginBottom: 20 }} />
        </>
      )}
      {childrenArray.map((c) => {
        return c;
      })}
    </Box>
  );
};

export const SettingsPageContainer = ({
  handleSave,
  isTouched,
  dataLoading,
  children,
  title,
}: {
  handleSave?: () => void;
  isTouched?: boolean;
  dataLoading?: boolean;
  children: React.ReactNode;
  title?: string;
}) => {
  return (
    <React.Fragment>
      <AdminAppBar>
        <AdminToolbar title={title || "Settings"}>
          {isTouched && handleSave && (
            <Fab
              aria-label="logout"
              color={"primary"}
              disabled={false}
              onClick={() => handleSave()}
              size="medium"
            >
              <Save />
            </Fab>
          )}
        </AdminToolbar>
        <Container
          fixed
          sx={{
            overflowY: "scroll",
            height: "90vh",
          }}
        >
          {children}

          {/* SAVE SETTINGS SECTION */}
          {handleSave && (
            <StyledBox
              title={"Save settings"}
              description={
                isTouched
                  ? "You need to save your changes before they are applied to the live application"
                  : "No changes detected"
              }
            >
              <LoadingButton
                loading={dataLoading}
                disabled={!isTouched}
                type="button"
                variant="contained"
                onClick={() => {
                  handleSave && handleSave();
                }}
              >
                Save changes
              </LoadingButton>
            </StyledBox>
          )}
        </Container>
      </AdminAppBar>
    </React.Fragment>
  );
};
